import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Upload, Search, CheckCircle } from 'lucide-react';
const steps = [{
  number: 1,
  icon: Upload,
  title: 'Envía tu estado de cuenta actual',
  description: 'Comparte tu merchant statement más reciente para que podamos analizarlo.'
}, {
  number: 2,
  icon: Search,
  title: 'Analizamos fees, servicio y operación',
  description: 'Revisamos cada detalle: tarifas, cargos ocultos, servicio y equipo.'
}, {
  number: 3,
  icon: CheckCircle,
  title: 'Solo te presentamos una opción si realmente mejora tu situación',
  description: 'Sin presión. Si no podemos mejorar lo que tienes, te lo decimos honestamente.'
}];
export function HowItWorksSection() {
  return <section id="como-funciona" className="bg-white py-16 md:py-24" data-id="element-69">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-70">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-71">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-4" data-id="element-72">
            Cómo Funciona
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-73">
            Un proceso simple y transparente diseñado para tu tranquilidad
          </p>
        </motion.div>

        <div className="relative" data-id="element-74">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gray-200 -translate-y-1/2 -z-10" data-id="element-75"></div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12" data-id="element-76">
            {steps.map((step, index) => {
            const Icon = step.icon;
            return <motion.div key={index} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: index * 0.2
            }} className="relative" data-id="element-77">
                  <div className="bg-white p-8 rounded-lg text-center" data-id="element-78">
                    <div className="w-16 h-16 bg-gold rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" data-id="element-79">
                      <span className="text-2xl font-bold text-navy" data-id="element-80">
                        {step.number}
                      </span>
                    </div>
                    <div className="w-12 h-12 bg-navy bg-opacity-10 rounded-lg flex items-center justify-center mx-auto mb-4" data-id="element-81">
                      <Icon className="text-navy" size={24} data-id="element-82" />
                    </div>
                    <h3 className="text-xl font-semibold mb-3 text-navy" data-id="element-83">
                      {step.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-84">{step.description}</p>
                  </div>
                </motion.div>;
          })}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mt-12" data-id="element-85">
          <Link to="/contacto" className="inline-block bg-navy text-white px-8 py-4 rounded-md font-semibold hover:bg-opacity-90 transition-all shadow-lg" data-id="element-86">
            Comienza tu evaluación
          </Link>
        </motion.div>
      </div>
    </section>;
}